export const BACKEND_URL = process.env.BACKEND_URL;

export const MOBILE_RESOLUTION = 495;
export const TABLET_RESOLUTION = 1024;

export enum ThemeVariant {
  Dark = 'dark',
  Light = 'light',
}
